import { render, staticRenderFns } from "./ReceiptRejectDetailQuery.vue?vue&type=template&id=15b26bb4&scoped=true"
import script from "./ReceiptRejectDetailQuery.vue?vue&type=script&lang=js"
export * from "./ReceiptRejectDetailQuery.vue?vue&type=script&lang=js"
import style0 from "./ReceiptRejectDetailQuery.vue?vue&type=style&index=0&id=15b26bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b26bb4",
  null
  
)

export default component.exports